<template>
  <div class="progress_bar_container">
    
    <div class="row">
      <div class="col-7">

        <div class="progress_bar_outer">
          <div class="progress_bar"
          :style="{width: progress_percent + '%'}"
          ></div>
        </div>
        
      </div>
      <div class="col-5">

        <div class="progress_bar_counts">
          {{current_count}} / {{max_count}}
        </div>
        
      </div>
    </div>

  </div>
</template>

<script>
import CardGeneric from '@/components/cards/card_generic.vue'

export default {
  name: 'progress_bar',
  props: [
    'current_count',
    'max_count'
  ],
  data () {
    return {
      
    }
  },
  mounted() {

  },
  computed: {
    progress_percent: function() {
      let vm = this;
      
      if(vm.current_count == 0) {
        return 0;
      }
      if(vm.current_count == vm.max_count) {
        return 100;
      }

      let percent = parseInt(vm.current_count) / parseInt(vm.max_count);
      percent = percent * 100;
      percent = percent.toFixed(1);

      return percent;
    }
  },
  methods: {
    set_progress: function() {

    }
  },
  components: {
    CardGeneric
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

.progress_bar_container {

  background: #197a7a;
  border-top: solid 4px #1f9696;

  .progress_bar_outer {

    border: solid 1px #CCC;
    border-radius: 5px;
    padding: 0;
    width: 100%;
    text-align: center;
    height: 1em;
    margin: 0.5em 1em;
    background: #FFF;

    .progress_bar {
      background: $dcom-orange;
      height: 100%;
    }
  }

  .progress_bar_counts {
    padding: 0.15rem;
    text-align: right;
    margin-right: 1em;
    color: #FFF;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/progress_bar/progress_bar.vue